import shiftReducer from "./reducers";

export default shiftReducer;